import request from '@/router/axios';

// 获取实习译员池列表
export function internPage(obj) {
  return request({
    url: '/dotadmin/dotIntern/internPage',
    method: 'post',
    data: obj,
  });
}

// 获取实习批次集合
export function internBatchList(obj) {
  return request({
    url: '/dotadmin/dotIntern/internBatchList',
    method: 'post',
    data: obj,
  });
}

// 新增实习生
export function addIntern(obj) {
  return request({
    url: '/dotadmin/dotIntern/addIntern',
    method: 'post',
    data: obj,
  });
}

// 移入正式库
export function internToFormalTr(obj) {
  return request({
    url: '/dotadmin/dotIntern/internToFormalTr/' + obj.trId,
    method: 'post',
    data: obj,
  });
}

// 结束实习
export function finishInternBatch(obj) {
  return request({
    url: '/dotadmin/dotIntern/finishInternBatch/' + obj.id,
    method: 'post',
    data: obj,
  });
}

// 获取语种
export function getLan() {
  return request({
    url: '/dotadmin/dotIntern/getLan',
    method: 'get',
  });
}

// 查询实习生
export function getIntern(obj) {
  return request({
    url: '/dotadmin/dotIntern/getIntern',
    method: 'get',
    params: obj,
  });
}

// 编辑实习生
export function updateIntern(obj) {
  return request({
    url: '/dotadmin/dotIntern/updateIntern',
    method: 'post',
    data: obj,
  });
}
